/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function FeesTaggingContainer({
  getFeeCodes,
  feeCodesList,

  getFeeSettings,
  feeSettings,
  updateFeeSettings,
}) {

  {/* Discount and Penalty Settings: */}
  const [codeFeesListFormat, setCodeFeesListFormat] = useState([]); // description 
  const [codeSettingListFormat, setCodeSettingListFormat] = useState([]); // discount & penalty
  const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);
  const [feeCodes, setFeeCodes] = useState({
    DISCOUNT: {
      fee_codes: [],
      type:'DISCOUNT'
    },
    PENALTY: {
      fee_codes: [],
      type:'PENALTY'
    }
  })

  const formatFormData = () => {
    if(!_.isEmpty(feeSettings)) {
      const list = feeSettings.map(item => {
        return {
          // id: item.id,
          // fee_code_list: [_.get(item, "attributes.fee_code")],
          type: _.get(item, "attributes.type"),
          fee_code: _.get(item, "attributes.fee_code"),
        }
      })

      setCodeSettingListFormat(list)
      setFormData(list)
    }
  }

  useEffect(() => {
    getFeeCodes();
    getFeeSettings();
  }, []);
  
  useEffect(() => {
    formatFormData();
  }, [feeSettings]);

  useEffect(() => {
    if (!_.isEmpty(_.get(feeCodesList, "fees"))) {
      setCodeFeesListFormat(_.get(feeCodesList, "fees"));
    }
  }, [_.get(feeCodesList, "fees"), formData]);

  // retrieve initial data and map into array of FEE_CODES (for onSubmit)
  const formatFeeCodes = () => {
    const filterFeeType = type => {
      let arrItem = []

      formData.filter(item => `${item.type}` === type)
        .map(data => arrItem.push(`${data.fee_code}`))
      
      return setFeeCodes(prevFeeCodes => {
        return {
          ...prevFeeCodes,
          [type]: {
            ...prevFeeCodes[type],
            fee_codes: [...arrItem].sort(),
          }
        }
      })
    }

    filterFeeType("PENALTY")
    filterFeeType("DISCOUNT")
  }

  useEffect(() => {
    formatFeeCodes()
  }, [formData])

    // TEMPORARY FIX FOR MINOR BUG
    const handleSetMode = (num) => {
      setMode(num);
    };

  const renderCheckbox = (code, type) => {
    const item = formData.filter(data => +data.fee_code === +code && data.type === type) || {}

    return (
      <button type="button" className="btn-blank"
        onClick={handleToggle(code, type)}
      >
        {_.isEmpty(item) 
          ? (<i className="far fa-square icon-check-box" />)
          : (<i className="fas fa-check-square icon-box" />)}
      </button>
    );
  }

  const handleToggle = (code, type) => () => {
    handleSetMode(1);
    const item = formData.find(data => +data.fee_code === +code && data.type === type) || {}
    
    if(_.isEmpty(item)) {
      setFormData(_.concat(formData, {
        type, 
        fee_code: code,
      }))
      setFeeCodes(prevFeeCodes => {
        return {
          ...prevFeeCodes,
          [type]: {
            fee_codes: [..._.get(prevFeeCodes, `${type}.fee_codes`), code],
            type,
          }
        }
      })

      return true
    }

    if(!_.isEmpty(item)) {
      setFormData(_.reject(formData, item))
      setFeeCodes(prevFeeCodes => {
        const newItem = _.get(prevFeeCodes, `${type}.fee_codes`)
          .filter(item => item !== code)
          .sort()

        return {
          ...prevFeeCodes, 
          [type]: {
            fee_codes: [...newItem],
            type,
          }
        }
      })
      return true
    }
  };

  const handleSubmit = () => {
    handleSetMode(0);
    const args = {
      fee_settings: [...Object.values(feeCodes)]
    }
    updateFeeSettings(args)
  };

  const handleCancel = () => {
    setFormData(codeSettingListFormat);
    handleSetMode(0);
  };

  // filter unique items(type) in an array of object
  // const filterDuplicateCodeSettingsList = [...new Map(codeSettingListFormat.map((item) => [item["type"], item])).values()].sort();

  return (
    <div className="card p-0">
      <div className="card p-0">
        <div className="card-content-listing">
          <div className="container-fluid p-0">
            <div className="row">
              <div className="col-6">
                <h3>Fees Tagging</h3>
              </div>
              {/* listing */}
              <div className="col-6 d-flex">
                {mode === 1 ? (
                    <React.Fragment>
                      <button
                        type="button"
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold ml-auto px-4 mr-1"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary btn-round font-weight-bold px-4"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    </React.Fragment>
                  ) : ''
                }
              </div>
            </div>
              {/* TABLE */}
            <div className="table-responsive mt-4">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    { !_.isEmpty(codeSettingListFormat) ? 
                    <>
                      <th scope="col" className="px-1">Fees Description</th>
                      <th scope="col" className="px-1">
                        <div className="w-100 text-center">
                          DISCOUNT
                        </div>
                      </th>
                      <th scope="col" className="px-1">
                        <div className="w-100 text-center">
                          PENALTY
                        </div>
                      </th>
                    </>
                    : <th scope="col">Fees Description</th>}
                  </tr>
                </thead>
                <tbody>
                  {!_.isEmpty(codeFeesListFormat) ?
                    <>{codeFeesListFormat.map((item, i) => {                      
                        return (
                          <>
                            <tr className="top-border" key={item.id}>
                              <td className="font-weight-bold py-3">
                                {_.get(item, "code")} - {_.get(item, "description")}
                              </td>
                                <td className="py-3">
                                  <div className="w-100 text-center">
                                    {renderCheckbox(item.code, "DISCOUNT")}
                                  </div>
                                </td>
                                <td className="py-3">
                                  <div className="w-100 text-center">
                                    {renderCheckbox(item.code, "PENALTY")}
                                  </div>
                                </td>

                            </tr>
                          </>
                        )}
                      )}
                    </>
                     : (<tr />)
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

FeesTaggingContainer.propTypes = {  
  getFeeCodes: PropTypes.instanceOf(Function).isRequired,
  feeCodesList: PropTypes.instanceOf(Object).isRequired,

  getFeeSettings: PropTypes.instanceOf(Function).isRequired,
  feeSettings: PropTypes.instanceOf(Object).isRequired,
  updateFeeSettings: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  feeCodesList: _.get(api, `${c.GET_FEE_CODES}.res`) || [],
  feeSettings: _.get(api, `${c.GET_FEE_SETTINGS}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FeesTaggingContainer);
